import PropTypes from 'prop-types';
const HELP_CENTER_URL = 'https://help.donorschoose.org/hc/en-us/articles/360060239973';

const HelpCenterLink = () => {
    return <a href={HELP_CENTER_URL} target="_blank" rel="noopener noreferrer">read more about why this happens</a>;
};

const ReplacementsChosenIntro = () => {
    return (
        <p>
           *Some of these resources were not available at the time of funding (<HelpCenterLink />)
           and the teacher has selected some replacement items:
        </p>
    );
};

const ReplacementsChosenGiftCodeIntro = () => {
    return (
        <p>
            *Some of these resources were not available at the time of funding (<HelpCenterLink />).
            The teacher received a DonorsChoose credit for some items to apply to their next classroom project,
            and has selected some replacement items:
        </p>
    );
};

const ReplacementsNotChosenGiftCodeIntro = () => {
    return (
        <p>
            *Some of these resources were not available at the time of funding (<HelpCenterLink />), and could not be
            replaced with other items. The teacher received a DonorsChoose credit to apply to their next classroom project.
        </p>
    );
};

const ReplacementsNotChosenIntro = () => {
    return (
        <p>
            *Some of these resources were not available at the time of funding (<HelpCenterLink />),
            so the teacher will select replacement items.
        </p>
    );
};

const ReplacementRow = ({ itemName, vendorName, hideVendorNames }) => {
    if (hideVendorNames) {
        return (<li>{itemName}</li>);
    }
    return (<li>{itemName} &middot; <span className="vendor">{vendorName}</span></li>);
};

ReplacementRow.propTypes = {
    itemName: PropTypes.string,
    vendorName: PropTypes.string,
    hideVendorNames: PropTypes.bool,
};

export const ResourceReplacements = ({ data }) => {
    if (data.hasGiftCode && !data.replacementResourceNames) {
        return <div><ReplacementsNotChosenGiftCodeIntro /></div>;
    }
    if (!data.replacementResourceNames) {
        return <div><ReplacementsNotChosenIntro /></div>;
    }

    const hideVendorNames = data.hideVendorNames;

    return (
        <div>
            {data.hasGiftCode ? <ReplacementsChosenGiftCodeIntro/> : <ReplacementsChosenIntro/> }
            <ul>
                {data.replacementResourceNames.map((n, i) => <ReplacementRow itemName={n.itemName} vendorName={n.vendorName} hideVendorNames={hideVendorNames} key={i} />)}
            </ul>
        </div>
    );
};

ResourceReplacements.propTypes = {
    data: PropTypes.object.isRequired,
};
